import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";

import { Subscription } from "rxjs";
import "rxjs/add/operator/filter";

import { AutenticazioneService } from "@app/shared/services/autenticazione.service";
import { UtenteVO } from "@app/shared/vo/utenteVO";
import { env } from "@env/environment";

@Component({
  // tslint:disable-next-line:component-selector
  selector: "user-circle",
  templateUrl: "usercircle.component.html"
})
export class UserCircleComponent implements OnInit, OnDestroy {
  subscription: Subscription;

  numeroDaAggiornare: String;
  utente: UtenteVO;
  riservato: boolean = false;

  constructor(private autenticazioneService: AutenticazioneService) {
    this.subscription = autenticazioneService.utenteAnnounced$.subscribe(
      utenteRicevuto => {
        // console.log("utente ricevuto: ", utenteRicevuto);
        this.utente = utenteRicevuto;
        if (this.utente == null) {
          console.log("utente non autenticato");
        } else {
          this.riservato = false;
          this.utente.profili.forEach(element => {
            element.autorizzazioni.forEach(autorizzazione => {
              if (autorizzazione.codice === "AR") {
                this.riservato = true;
              }
            });
          });
        }
      }
    );
  }
  ngOnInit(): void { }

  logout() {
    sessionStorage.removeItem(env.APP_KEY + btoa(window.location.pathname));
    this.autenticazioneService.logOut();
  }


  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscription.unsubscribe();
  }
}
